// extracted by mini-css-extract-plugin
export var optionGrid = "_96-7";
export var optionList = "_96-6";
export var questionsBlock = "_96-9";
export var spacer = "_96-5";
export var stepCenteredContent = "_96-3";
export var stepInner = "_96-0";
export var stepInnerFullWidth = "_96-1";
export var stepInnerLockScroll = "_96-2";
export var stepTransitionFrame = "_96-4";
export var welcomeBlock = "_96-8";